import { render, staticRenderFns } from "./ReturnGoods.vue?vue&type=template&id=5c5b13de"
import script from "./ReturnGoods.vue?vue&type=script&lang=js"
export * from "./ReturnGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports